import * as apiService from "../api.service";
import ModuleSetting, {
	NewModuleSetting,
	UpdatedModuleSetting,
} from "../../models/ModuleSetting";
import { isAxiosError } from "axios";
import {
	ModuleBillingNotActive,
	ModuleSettingMaxAmountExceededError,
} from "./errors";

export async function getModuleSettingsForUser(
	userId: string
): Promise<ModuleSetting[]> {
	const response = await apiService.GET(`/user/${userId}/moduleSettings`);

	return (response.data as any[]).map(ModuleSetting.fromJson);
}

export async function updateModuleSetting(
	moduleSetting: UpdatedModuleSetting
): Promise<void> {
	try {
		await apiService.PUT(
			`/moduleSetting/${moduleSetting.moduleSettingId}`,
			ModuleSetting.convertForJson(moduleSetting)
		);
	} catch (error) {
		console.log(error);
		throw error;
	}
}

export async function createNewModuleSetting(
	moduleSettings: NewModuleSetting[]
): Promise<void> {
	try {
		await apiService.POST(
			`/moduleSetting`,
			moduleSettings.map(ModuleSetting.convertForJson)
		);
	} catch (error) {
		if (isAxiosError(error)) {
			if (error.response?.data.type === "module-billing-not-active") {
				throw new ModuleBillingNotActive(error.response?.data.module);
			}
			if (error.response?.data.type === "module-setting-max-amount-exceeded") {
				throw new ModuleSettingMaxAmountExceededError(
					error.response.data.moduleId,
					error.response.data.maxAmountAllowed / 100 // from cents to euros
				);
			}
		}
		console.log(error);
		throw error;
	}
}

export async function deleteModuleSetting(moduleSettingId: string) {
	try {
		await apiService.DELETE("moduleSetting/" + moduleSettingId);
	} catch (error) {
		console.log(error);
		throw error;
	}
}
